"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Fluxible = require("fluxible");
const fetchrPlugin = require("fluxible-plugin-fetchr");
const Application_1 = require("./frontend/components/Application");
const ApplicationStore_1 = require("./frontend/stores/ApplicationStore");
const BlogStore_1 = require("./frontend/stores/BlogStore");
const RouteStore_1 = require("./frontend/stores/RouteStore");
const GalleryStore_1 = require("./frontend/stores/GalleryStore");
const HomeStore_1 = require("./frontend/stores/HomeStore");
// create new fluxible instance
const app = new Fluxible({
    component: Application_1.default,
});
const fetchrPluginInst = fetchrPlugin({
    xhrPath: '/api',
});
app.plug(fetchrPluginInst);
// register stores
app.registerStore(RouteStore_1.default);
app.registerStore(ApplicationStore_1.default);
app.registerStore(BlogStore_1.default);
app.registerStore(GalleryStore_1.default);
app.registerStore(HomeStore_1.default);
exports.default = app;
